import type { AndExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const andResolver = createSimpleNamedExpressionResolver<AndExpression>(
  'and',
  values => values?.length > 0 && values.every(value => !!value)
);
